import { useFetch } from 'hooks/fetch/useFetch'
import { HIGHLIGHTS } from 'api/api'

export const useFetch_Highlights = () => {

  const { D:highlights } = useFetch({url:HIGHLIGHTS,file:'useFetch_Highlights.jsx'})
  const res = highlights?.length ? true : false
  return { highlights, res }

}